import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { Calendar, UserPlus, MessageCircle } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { haptic } from '../../utils/haptics';

const tabs = [
  { to: '/', icon: Calendar, label: 'Calendar', tour: 'nav-calendar' },
  { to: '/friends', icon: UserPlus, label: 'Friends', tour: 'nav-friends' },
  { to: '/messages', icon: MessageCircle, label: 'Messages', tour: 'nav-messages' },
];

export function BottomNav() {
  const { unreadMessageCount, groupChats, groupMembers, groupMessages, currentUser, pendingRequests } = useApp();

  // Count group unread messages (localStorage-based read tracking)
  const groupUnread = useMemo(() => {
    let count = 0;
    for (const gc of groupChats) {
      const myMembership = groupMembers.find(
        (gm) => gm.groupId === gc.id && gm.userId === currentUser.id,
      );
      if (!myMembership) continue;
      const msgs = groupMessages.filter((m) => {
        if (m.groupId !== gc.id || m.senderId === currentUser.id) return false;
        if (myMembership.deletedAt && new Date(m.createdAt) <= new Date(myMembership.deletedAt)) return false;
        return true;
      });
      const lastRead = localStorage.getItem(`rostfound_group_read_${gc.id}`);
      if (lastRead) {
        count += msgs.filter((m) => new Date(m.createdAt) > new Date(lastRead)).length;
      } else {
        count += msgs.length;
      }
    }
    return count;
  }, [groupChats, groupMembers, groupMessages, currentUser.id]);

  const totalUnread = unreadMessageCount + groupUnread;

  return (
    <nav className="border-t border-slate-700/50 bg-slate-800 shrink-0" style={{ paddingBottom: 'var(--sab)' }}>
      <div className="flex px-2">
        {tabs.map(({ to, icon: Icon, label, tour }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            data-tour={tour}
            onClick={() => haptic()}
            className="flex-1 flex flex-col items-center py-2.5 text-xs active:scale-95 transition-transform"
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon
                    size={22}
                    className={isActive ? 'text-accent' : 'text-slate-500'}
                  />
                  {to === '/messages' && totalUnread > 0 && (
                    <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-accent text-xs font-bold text-white px-1">
                      {totalUnread > 9 ? '9+' : totalUnread}
                    </span>
                  )}
                  {to === '/friends' && pendingRequests.length > 0 && (
                    <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-accent text-xs font-bold text-white px-1">
                      {pendingRequests.length > 9 ? '9+' : pendingRequests.length}
                    </span>
                  )}
                </div>
                <span
                  className={`mt-1 text-xs font-medium ${isActive ? 'text-accent' : 'text-slate-500'}`}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
